var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.25H11.25C11.9375 1.25 12.5 1.8125 12.5 2.5V5.2H2.5V2.5C2.5 1.8125 3.0625 1.25 3.75 1.25Z",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.19922V7.42422C2.5 8.09922 2.86252 8.72421 3.45627 9.05546L5.30624 10.0992C5.69999 10.3179 5.94376 10.7367 5.94376 11.1867V12.4992C5.94376 13.1867 6.50626 13.7492 7.19376 13.7492H7.81876C8.50626 13.7492 9.06876 13.1867 9.06876 12.4992V11.1867C9.06876 10.7367 9.31252 10.3179 9.70627 10.0992L11.5562 9.05546C12.1437 8.72421 12.5125 8.09922 12.5125 7.42422V5.19922H2.5Z",
    stroke: "#30322C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.7dbc03906b990751df37c8ff7272073b.svg";
export { ForwardRef as ReactComponent };